import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { Plus, Edit, Trash2, Podcast } from 'lucide-react';

export default function EpisodesManager() {
  const [episodes, setEpisodes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEpisodes();
  }, []);

  const loadEpisodes = async () => {
    try {
      const { data, error } = await supabase
        .from('episodes')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      setEpisodes(data || []);
    } catch (error) {
      console.error('Error loading episodes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: string) => {
    if (!confirm('Are you sure you want to delete this episode?')) return;

    try {
      const { error } = await supabase.from('episodes').delete().eq('id', id);
      if (error) throw error;
      await loadEpisodes();
    } catch (error) {
      console.error('Error deleting episode:', error);
      alert('Failed to delete episode');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-yellow-400 font-horizon text-2xl animate-pulse">
          Loading Episodes...
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-horizon text-3xl text-yellow-400">Episodes</h1>
        <button className="flex items-center gap-2 px-4 py-2 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-colors">
          <Plus size={20} />
          New Episode
        </button>
      </div>

      <div className="space-y-4">
        {episodes.map((episode) => (
          <div
            key={episode.id}
            className="bg-gradient-to-br from-red-900/20 to-black border border-yellow-400/30 rounded-xl p-6 hover:border-yellow-400/60 transition-colors"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-red-500 text-white px-2 py-1 text-xs font-bold">
                    {episode.podcast_number}
                  </span>
                  <h3 className="text-white font-bold text-xl">{episode.title}</h3>
                </div>
                <p className="text-gray-400 mb-3">{episode.description}</p>
                {episode.guests && (
                  <p className="text-gray-500 text-sm">Guests: {episode.guests}</p>
                )}
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                <Edit size={16} />
                Edit
              </button>
              <button
                onClick={() => handleDelete(episode.id)}
                className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                <Trash2 size={16} />
                Delete
              </button>
            </div>
          </div>
        ))}

        {episodes.length === 0 && (
          <div className="text-center py-12 text-gray-400">
            <Podcast size={48} className="mx-auto mb-4 opacity-50" />
            <p className="text-lg">No episodes yet. Create your first episode!</p>
          </div>
        )}
      </div>
    </div>
  );
}
